import { compose, prop, sortBy, toLower } from "ramda"

export const sortListBy = fieldName => sortBy(compose(toLower, prop(fieldName)))

export const sortListByName = sortListBy("name")
export const sortListByLabel = sortListBy("label")
